module.exports = {
  table_header_background: "#e9f1fd",
};
